// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eE3B","col":"styles_col__2qKw5"};